class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(() => {
  if (window.preetKaurCartDrawerCheckoutNormalizer) return;
  window.preetKaurCartDrawerCheckoutNormalizer = true;

  const nativeCheckoutUrl = 'https://preetkaur.co/checkout';
  const nativeSelector =
    '#CartDrawer-InternationalCheckout, #CartNotification-InternationalCheckout, #CartDrawer-NativeCheckout, #CartNotification-NativeCheckout, [data-native-checkout-link]';
  const magicSelector = '#checkout2, [name="checkout2"]';

  function isIndiaMarket() {
    return window.preetKaurIsIndiaMarket === true || (window.Shopify && window.Shopify.country === 'IN');
  }

  function setFullWidth(element) {
    if (!element) return;
    element.style.width = '100%';
    element.style.maxWidth = 'none';
    element.style.margin = '0';
  }

  function setStackedContainer(container) {
    if (!container || !container.classList.contains('cart__ctas')) return;
    container.classList.add('cart__ctas--market-checkout');
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '1rem';
  }

  function normalizeNativeLink(nativeCheckoutLink, label) {
    nativeCheckoutLink.setAttribute('data-native-checkout-link', '');
    nativeCheckoutLink.setAttribute('data-native-checkout-normalized', 'true');

    if (nativeCheckoutLink.tagName === 'A') {
      nativeCheckoutLink.setAttribute('href', nativeCheckoutUrl);
      nativeCheckoutLink.setAttribute('rel', 'nofollow');
    }

    nativeCheckoutLink.className = 'button button--full-width';
    nativeCheckoutLink.removeAttribute('name');
    nativeCheckoutLink.onclick = null;
    nativeCheckoutLink.textContent = label;
    setFullWidth(nativeCheckoutLink);
  }

  function createNativeLink(container, label) {
    const nativeCheckoutLink = document.createElement('a');
    nativeCheckoutLink.id = container.classList.contains('cart-notification__links')
      ? 'CartNotification-NativeCheckout'
      : 'CartDrawer-NativeCheckout';
    normalizeNativeLink(nativeCheckoutLink, label);
    return nativeCheckoutLink;
  }

  function getMagicBlock(magicCheckoutButton) {
    return magicCheckoutButton ? magicCheckoutButton.closest('form') || magicCheckoutButton : null;
  }

  function insertBeforeContinueShopping(container, element) {
    const continueShoppingButton = container.querySelector('.button-label');
    if (continueShoppingButton) {
      container.insertBefore(element, continueShoppingButton);
    } else {
      container.appendChild(element);
    }
  }

  function normalizeContainer(container) {
    const indiaMarket = isIndiaMarket();
    const magicCheckoutButton = container.querySelector(magicSelector);
    const magicBlock = getMagicBlock(magicCheckoutButton);
    let nativeCheckoutLink = container.querySelector(nativeSelector);

    setStackedContainer(container);

    if (indiaMarket) {
      if (magicCheckoutButton) {
        magicCheckoutButton.textContent = 'Indian Orders';
        setFullWidth(magicCheckoutButton);
      }

      if (!nativeCheckoutLink) {
        nativeCheckoutLink = createNativeLink(container, 'International orders');
      } else {
        normalizeNativeLink(nativeCheckoutLink, 'International orders');
      }

      if (magicBlock) {
        magicBlock.insertAdjacentElement('afterend', nativeCheckoutLink);
      } else {
        insertBeforeContinueShopping(container, nativeCheckoutLink);
      }

      return;
    }

    if (!nativeCheckoutLink) {
      nativeCheckoutLink = createNativeLink(container, 'Checkout');
      if (magicBlock) {
        magicBlock.insertAdjacentElement('afterend', nativeCheckoutLink);
      } else {
        insertBeforeContinueShopping(container, nativeCheckoutLink);
      }
    } else {
      normalizeNativeLink(nativeCheckoutLink, 'Checkout');
    }

    if (magicBlock) {
      magicBlock.remove();
    }
  }

  function normalizeCheckoutButtons(root = document) {
    const scope = root.querySelectorAll ? root : document;
    const containers = [];

    if (scope.matches && scope.matches('.cart__ctas, .cart-notification__links')) {
      containers.push(scope);
    }

    scope.querySelectorAll('.cart__ctas, .cart-notification__links').forEach((container) => {
      if (!containers.includes(container)) {
        containers.push(container);
      }
    });

    containers.forEach(normalizeContainer);
  }

  window.preetKaurNormalizeCheckoutButtons = window.preetKaurNormalizeCheckoutButtons || normalizeCheckoutButtons;

  document.addEventListener(
    'click',
    (event) => {
      const nativeCheckoutLink = event.target.closest(nativeSelector);
      if (!nativeCheckoutLink) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(nativeCheckoutUrl);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeCheckoutButtons(document));
  } else {
    normalizeCheckoutButtons(document);
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          normalizeCheckoutButtons(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
